export default {
  messages: {
    date_not_future:
      "Tanggal yang dipilih sudah lewat. Silakan pilih tanggal yang akan datang",
  },
};
